import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/lib/components/Select";
import { cn } from "@/lib/utils";

export const TEXT_TRANSFORM_OPTIONS = [
  "capitalize",
  "uppercase",
  "lowercase",
] as const;

export type TextTransformOption = (typeof TEXT_TRANSFORM_OPTIONS)[number];
export type TextTransformSelectValue = "NONE" | TextTransformOption;

const TEXT_TRANSFORM_LABELS: Record<TextTransformSelectValue, string> = {
  NONE: "No text transform",
  capitalize: "Capitalize",
  uppercase: "Uppercase",
  lowercase: "Lowercase",
};

const TEXT_TRANSFORM_SELECT_OPTIONS: TextTransformSelectValue[] = [
  "NONE",
  ...TEXT_TRANSFORM_OPTIONS,
];

type TextTransformSelectProps = {
  value: TextTransformSelectValue;
  onValueChange: (value: TextTransformSelectValue) => void;
};

export function TextTransformSelect({
  value,
  onValueChange,
}: TextTransformSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger
        className={cn("h-9 w-50", value === "NONE" && "text-text-secondary")}
      >
        <SelectValue>{TEXT_TRANSFORM_LABELS[value]}</SelectValue>
      </SelectTrigger>
      <SelectContent>
        {TEXT_TRANSFORM_SELECT_OPTIONS.map((option) => (
          <SelectItem key={option} value={option}>
            {TEXT_TRANSFORM_LABELS[option]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
